<agr-page-toolbar [pageTitle]="'unauthorized.title' | translate" data-test="unauthorized">
  <div class="spacing--margin-horizontal spacing--margin-top">
    <p>{{ 'unauthorized.message' | translate }}</p>
    <button mat-flat-button color="primary" (click)="logout()">
      <mat-icon>logout</mat-icon>{{ 'signout' | translate }}
    </button>
  </div>
</agr-page-toolbar>
